// @ts-nocheck
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import BunzlAutoCompleteProductBody, {
    BunzlAutoCompleteProductBodyStyles,
} from "@store/Library/Components/Bunzl/AutoComplete/BunzlAutoCompleteProductBody";
import BunzlAutoCompleteProductFooter, {
    BunzlAutoCompleteProductFooterStyles,
} from "@store/Library/Components/Bunzl/AutoComplete/BunzlAutoCompleteProductFooter";
import BunzlAutoCompleteProductWrapper, {
    BunzlAutoCompleteProductWrapperStyles,
} from "@store/Library/Components/Bunzl/AutoComplete/BunzlAutoCompleteProductWrapper";
import React from "react";

export interface BunzlAutoCompleteProductStyles {
    bunzlAutoCompleteBodyStyles?: BunzlAutoCompleteProductBodyStyles;
    bunzlAutoCompleteFooterStyles?: BunzlAutoCompleteProductFooterStyles;
    bunzlautoCompleteProductWrapperStyles?: BunzlAutoCompleteProductWrapperStyles;
}
interface BunzlAutoCompleteProductProps {
    isAuthenticated: boolean;
    autocompleteProductItem: ProductAutocompleteItemModel;
    goToUrl: (url: string) => void;
    onProductAction?: (url: string) => void;
    extendedStyles?: BunzlAutoCompleteProductStyles;
    variant?: "outlined" | "elevated";
    isFocused?: boolean;
}

const BunzlAutoCompleteProduct: React.FC<BunzlAutoCompleteProductProps> = ({
    isAuthenticated,
    autocompleteProductItem,
    goToUrl,
    onProductAction,
    extendedStyles,
    variant = "outlined",
    isFocused,
}) => {
    const { bunzlAutoCompleteBodyStyles, bunzlAutoCompleteFooterStyles, bunzlautoCompleteProductWrapperStyles } =
        extendedStyles ?? {};
    return (
        <BunzlAutoCompleteProductWrapper
            isFocused={isFocused}
            variant={variant}
            extendedStyles={bunzlautoCompleteProductWrapperStyles}
            data-test-selector={`autoComplete_product_${autocompleteProductItem.id}`}
        >
            <BunzlAutoCompleteProductBody
                extendedStyles={bunzlAutoCompleteBodyStyles}
                isAuthenticated={isAuthenticated}
                autocompleteProductItem={autocompleteProductItem}
                goToUrl={goToUrl}
                onProductAction={onProductAction}
            />
            <BunzlAutoCompleteProductFooter
                extendedStyles={bunzlAutoCompleteFooterStyles}
                isAuthenticated={isAuthenticated}
                autocompleteProductItem={autocompleteProductItem}
                goToUrl={goToUrl}
            />
        </BunzlAutoCompleteProductWrapper>
    );
};

export default BunzlAutoCompleteProduct;
